import { UserTypeEnum } from 'src/store/user/user';
import braze from '../braze';
import Sentry from '../sentry/Sentry';
import amplitude from '../amplitude';
import datadog from '../datadog';

export async function updateTrackingServicesWith({ id, userType }: { id: string | null; userType: UserTypeEnum }) {
  braze.setUserInfo(id, userType);
  Sentry.setUserInfo(id, userType);
  await amplitude.setUserInfo(id, userType);
  await datadog.setUserInfo(id, userType);
}
